const currencyNumber = new Intl.NumberFormat('en-US', {});

export const currencyFormatter = (price) => currencyNumber.format(price);